import config from '../../config';
import { ChallengeQuiz, QuizUserAnswers } from "../../model/ChallengeQuiz.model";
import AxiosHealthWellness from '../healthWellness';
import {VDO_SORTED_IDS_BDK2026} from './../../common/challengeConstants'

export const getChallengeQuiz = async (params) => {
    
    try {
        const response = await AxiosHealthWellness.get(
            `${config.API_URL}/hnw/challenge-external/quiz`,
            {
                params
            });
        const quizData = response?.data;
        const sortedExamParts = Array.isArray(quizData) ? quizData?.reduce((sorted, part) => {
            const index = VDO_SORTED_IDS_BDK2026.indexOf(part?.exam_part_id);
            if (index !== -1) {
              sorted[index] = part;
            } else {
              sorted.push(part);
            }
            return sorted;
          }, new Array(VDO_SORTED_IDS_BDK2026.length)).filter(Boolean) : [];
          return sortedExamParts?.map(round => new ChallengeQuiz(round));
          
    } catch (error) {
        throw error;
    }
};

export const updateQuizUserAnswers = async (examUserId, answers, isSendToChallenge) => {
    try {
        const response = await AxiosHealthWellness.put(`${config.API_URL}/hnw/challenge-external/quiz/answer`,
            {
                examUserId,
                answers,
                isSendToChallenge
            },
        );
        return response?.data?.request_id;
    } catch (error) {
        throw error;
    }
};

export const getUpdatedAnswers = async (requestId) => {

    try {
        const response = await AxiosHealthWellness.get(
            `${config.API_URL}/hnw/challenge-external/quiz/answer?requestId=${requestId}`);
        const isError = response?.data?.is_error;
        return isError ? response?.data : new QuizUserAnswers(response?.data?.processed_result);
    } catch (error) {
        throw error;
    }
};